export const PERIODO_INSCRICAO = {
    
    ENCERRADO: "ENCERRADO",
    ABERTO: "ABERTO",
    NAO_INICIADO: "NAO_INICIADO",
    
}